document.addEventListener("DOMContentLoaded", function() {
  // Variables
  const loadMoreButton = document.querySelector("#load-more-button"); // Ensure this matches your button's ID
  const productGrid = document.querySelector("#product-grid");
  let currentPage = 1;
  const totalPages = parseInt(loadMoreButton.getAttribute("data-total-pages"), 10); // Get the total pages from the button attribute

  // Load more products
  function loadMoreProducts() {
    if (currentPage >= totalPages) {
      loadMoreButton.style.display = "none"; // Hide the button if all pages are loaded
      return;
    }

    // Make the AJAX call to fetch more products
    currentPage++;
    fetch(`/collections/all?page=${currentPage}`)
      .then((response) => response.text())
      .then((data) => {
        const newProducts = new DOMParser().parseFromString(data, "text/html").querySelector("#product-grid").innerHTML;
        productGrid.innerHTML += newProducts; // Append new products to the grid

        // Check if it's the last page
        if (currentPage >= totalPages) {
          loadMoreButton.style.display = "none"; // Hide the button if all pages are loaded
        }
      })
      .catch((error) => {
        console.error("Error loading more products:", error);
      });
  }

  // Event listener for Load More button
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", loadMoreProducts);
  }
});
